<template>
  <div>
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <h6 class="h2 text-white d-inline-block mb-0">Productor</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>

        <div v-if="isDataLoaded" class="col-sm-6 col-xs-12 text-right">
          <router-link
            v-if="$can('store', 'documents')"
            :to="{ name: 'DocumentUpload', params: { id: producer.id, type: 'producers' } }"
            class="btn base-button btn-neutral btn-sm"
          >
            Subir Archivos&nbsp;<i class="fas fa-upload"></i>
          </router-link>

          <router-link
            v-if="$can('index', 'documents')"
            :to="{ name: 'ProducerDocuments', params: { id: producer.id } }"
            class="btn base-button btn-neutral btn-sm"
          >
            Ver Archivos&nbsp;<i class="fas fa-copy"></i>
          </router-link>
        </div>
      </div>
    </base-header>
    <div v-if="isDataLoaded" class="container-fluid mt--6">
      <div class="row">
        <div class="col-md-12 col-sm-12">
          <producer-data :hectares="totalHectares" :producer="producer" />
        </div>
      </div>
      <div v-if="$can('index', 'contacts')" class="row">
        <div class="col-md-12 col-sm-12">
          <contacts-list :entity-id="producerId" :title="contactsTitle" entity="producers">
            <template slot="title">
              <div class="row">
                <div class="col">
                  <h3 class="mb-0">Contactos</h3>
                </div>

                <div class="col text-right pr-5">
                  <router-link
                    v-if="$can('store', 'contacts')"
                    :to="{ name: 'ProducerCreateContact', params: { id: producerId } }"
                    class="btn btn-outline-warning btn-sm"
                  >
                    <i class="fas fa-user"></i>&nbsp;Agregar Contactos
                  </router-link>
                </div>
              </div>
            </template>
          </contacts-list>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 col-sm-12">
          <fields-list :producer="producer.id" />
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 col-sm-12">
          <plots-list :producer="producer.id" @plotsLoaded="setTotalHectares" />
        </div>
      </div>

      <div v-if="$can('index', 'orders')" class="row">
        <div class="col">
          <finalized-order-items-table title="Articulos Pedidos Por Variedad" :producer="producer.id" />
        </div>

        <div class="col">
          <orders-table :collapse="true" title="Pedidos" :filter-producer="producer.id" />
        </div>
      </div>

      <div v-if="$can('index', 'visits')" class="row">
        <div class="col-md-12 col-sm-12">
          <visits-table
            :filter-id="producer.id"
            :filter-type="'producers'"
            :show-author-filter="false"
            :title="visitsTitle"
          >
            <template slot="actions">
              <router-link
                v-if="$can('store', 'visits')"
                :to="{ name: 'ProducerCreateVisit', params: { id: producer.id } }"
                class="btn btn-outline-success btn-sm"
              >
                <i class="fas fa-calendar"></i>&nbsp;Nueva Visita
              </router-link>
            </template>
          </visits-table>
        </div>
      </div>
      <div v-if="$can('index', 'documents')" class="row">
        <div class="col">
          <documents-table
            :collapse="true"
            title="Documentos"
            :filter-producer="producer.id"
            :filter-documentable-type="documentableType"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
import ProducerData from '@/views/Producers/Show/ProducerData';
import FieldsList from '@/views/Producers/Show/FieldsList';
import PlotsList from '@/views/Producers/Show/PlotsList';
import VisitsTable from '@/views/Visits/List/VisitsTable';
import ContactsList from '@/views/Contacts/List/ContactsList';
import OrdersTable from '../Orders/List/OrdersTable';
import DocumentsTable from '../Documents/List/DocumentsTable';
import FinalizedOrderItemsTable from '../Orders/List/FinalizedOrderItemsTable';
import ResetTableFilterMixin from '@/mixins/resetTableFilterMixin';

export default {
  name: 'ProducersShow',
  components: {
    RouteBreadCrumb,
    ProducerData,
    FieldsList,
    PlotsList,
    VisitsTable,
    ContactsList,
    OrdersTable,
    DocumentsTable,
    FinalizedOrderItemsTable,
  },

  mixins: [ResetTableFilterMixin],
  props: {
    documentableType: {
      type: String,
      default: 'producers',
    },
  },

  data() {
    return {
      producerId: null,
      visitsTitle: 'Visitas del productor',
      contactsTitle: 'Contactos del productor',
      totalHectares: 0,
      isDataLoaded: false,
      producer: null,
    };
  },

  created() {
    this.mixSaveTableCurrentFilters('order');
    this.mixSaveTableCurrentFilters('visit');
    this.mixSaveTableCurrentFilters('document');
  },

  mounted() {
    this.producerId = +this.$route.params.id;
    this.fetchProducer();
  },

  beforeDestroy() {
    this.mixRetrieveTablePreviousFilters('order');
    this.mixRetrieveTablePreviousFilters('visit');
    this.mixRetrieveTablePreviousFilters('document');
  },

  methods: {
    fetchProducer() {
      const params = {
        include: ['city.province', 'distributor.seller', 'visitsCount', 'plotsCount', 'documentsCount'],
      };

      this.$services
        .resource('producers')
        .show(this.producerId, params)
        .then((res) => res.data.data)
        .then((producer) => {
          this.producer = producer;
          this.isDataLoaded = true;
          this.visitsTitle = `Visitas de ${producer.businessName}`;
          this.contactsTitle = `Contactos de ${producer.businessName}`;
        });
    },

    setTotalHectares(total) {
      this.totalHectares = total;
    },
  },
};
</script>
